import { Box, Button, Typography } from '@mui/material';
import { useErrorHandling } from '@/utils/errorHandling';
import styled from '@emotion/styled';
import { FlashIcon } from '@/icons/FlashIcon';
import { useTranslation } from 'react-i18next';
import { Accept, useDropzone } from 'react-dropzone';
import UsersAPIServiceV2 from '@/services/UserServiceV2';
import { useState } from 'react';
import { useLoader } from '@/contexts/loader/LoaderContext';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';

const UploadContainer = styled(Box)`
    border: 1px solid #eaecf0;
    text-align: center;
    width: 100%;
    border-radius: 5px;
    padding: 20px 0px;
`;

export type UploadFileProps = {
    onUploadSuccess: (fileUrl: string) => void;
    handleFileUpload?: (file: File) => void;
    description?: string;
    accept?: Accept;
};

export const UploadFile = (props: UploadFileProps) => {
    const { t } = useTranslation();
    const [_fileUrl, setFileUrl] = useState<string | null>(null);
    const { backendErrorHandler } = useErrorHandling();
    const { setLoading } = useLoader();
    const { setAlert } = useNotificationsSnackbar();

    const handleFileUpload = (file: File) => {
        if (file !== null) {
            setLoading(true);
            const formData = new FormData();
            formData.append('logo', file);
            UsersAPIServiceV2.getInstance()
                .uploadCompanyLogo({ formData })
                .then((response: any) => {
                    props.onUploadSuccess(response.data.fileUrl);
                    setFileUrl(response.data.fileUrl);
                })
                .catch(backendErrorHandler())
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDropAccepted: (acceptedFiles: File[]) => {
            if (props.handleFileUpload) {
                props.handleFileUpload(acceptedFiles[0]);
            } else {
                handleFileUpload(acceptedFiles[0]);
            }
        },
        onDropRejected: (_fileRejections: any) => {
            setAlert('File type not supported', 'error');
        },
        accept: props.accept
    });

    //TODO: refactor this to handle all types of file upload later

    return (
        <Box width={'100%'} marginTop={'10px'}>
            <UploadContainer {...getRootProps()}>
                <div style={{ justifySelf: 'center' }}>
                    <FlashIcon />
                </div>
                {isDragActive ? (
                    <Typography>{t('or_drag_and_drop')}</Typography>
                ) : (
                    <Box>
                        <Typography fontSize={12}>
                            <Button
                                component="label"
                                size="small"
                                sx={{ textTransform: 'initial' }}
                            >
                                {t('click_to_upload')}
                            </Button>
                            {t('or_drag_and_drop')}
                        </Typography>
                        <Typography fontSize={11}>
                            {props.description ?? 'SVG or PNG (max. 800x400px)'}
                        </Typography>
                    </Box>
                )}{' '}
                <input hidden type="file" {...getInputProps()} />
            </UploadContainer>
        </Box>
    );
};
